import { DataTypeConfig } from "../../../../types";

export const assetClassificationConfig: DataTypeConfig = {
  tabs: ["dataType"],
  searchableColumns: [
    "Asset Class",
    "Asset Type",
    "Dimension",
    "Data Type",
    "Unit",
    "Failure Modes",
  ],
  filterColumns: [
    { column: "Asset Class", type: "dropdown", label: "Asset Class" },
    { column: "Asset Type", type: "dropdown", label: "Asset Type" },
    { column: "Data Type", type: "dropdown", label: "Data Type" },
    { column: "Unit", type: "dropdown", label: "Unit" },
  ],
  tableColumns: [
    { key: "assetClass", header: "Asset Class", type: "custom" },
    { key: "assetType", header: "Asset Type", type: "custom" },
    { key: "dimension", header: "Dimension", type: "custom" },
    { key: "dataType", header: "Data Type", type: "badge" },
    { key: "unit", header: "Unit", type: "custom" },
    { key: "failureModes", header: "Failure Modes", type: "custom" },
  ],
  mandatoryFields: ["Asset Class", "Asset Type", "Dimension", "Unit"],
};

export const assetClassificationTabDisplayNames: Record<string, string> = {
  dataType: "Data Type",
};

export const assetClassificationTabDropdownOptions = (tabName: string) => {
  switch (tabName) {
    case "dataType":
      return [
        { value: "text", label: "Text" },
        { value: "number", label: "Number" },
        { value: "date", label: "Date" },
        { value: "boolean", label: "Boolean" },
      ];
    default:
      return [];
  }
};
